<template>
    <div class="mycards-wrapper">
        <div class="container">
            <div class="close-mycards" @click="closeCardWindow">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </div>
            <h2>Mis Cartas</h2>
            <div class="miscartas-wrapper">
                <div v-for="(card, index) in getMisCartas" :key="index" class="miscartas-carta">
                    <img :src="card.image" class="miscartas--image" />
                    <div class="download-link--img">
                        <a :href="card.image" download="mi_carta"><button class="button2">descarga</button></a>
                        <button class="deletecard-btn" @click="showConfirmation(index)"><!-- show confirm delete -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                </svg>
                        </button>
                    </div>
                    <div class="delete-card--confirmation-box" v-show="showConfirmationDialog && index === cardIndex">
                        <div class="delete-card--confirmation-box--inner">
                            <h4>Eliminar la tarjeta es una acción permanente.<br>¿Desea continuar?</h4>
                            <div class="delete-card--confirmation-box--actions">
                                <button class="delete-card--confirmation-box--confirm" @click="deleteCard(card.image)">borrar</button>
                                <button class="delete-card--confirmation-box--cancel" @click="cancelDelete">cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showDeleteMessage: false,
            showConfirmationDialog: false,
            cardIndex: null,
        }
    },

    methods: {
        closeCardWindow() {
            this.$emit('closeMyCards');
        },
        showConfirmation(index) {
            this.showConfirmationDialog = true;
            this.cardIndex = index;
        },
        deleteCard(imageToDelete) {
            this.showConfirmationDialog = false;
            this.cardIndex = null;
            let data = imageToDelete;
            this.$emit('deleteCard',data);
        },
        cancelDelete() {
            // Cancel the delete operation
            this.showConfirmationDialog = false;
            this.cardIndex = null;
            },
    },

    computed: {
        getMisCartas() {
            return this.$store.state.createdCards
        }
    }
}
</script>

<style lang="less">
.mycards-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 1000;
    background: #fff;
    overflow: auto;

    .container {
        padding-top: 4rem;
        position: relative;
    }
}

.close-mycards {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    svg {
        width: 2rem;
        height: auto;
    }
}

.miscartas-wrapper {
    display: flex;
    flex-wrap: wrap;
    & > div {
        width: calc(100% / 3);
        padding: 1rem;
    }
}

.miscartas--image {
    max-width: 315px;
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
    padding: 0;
    box-shadow: 0 2px 15px rgba(0,0,0,0.3);
}

@media(max-width: 768px) {
    .miscartas-wrapper {
        & > div {
            width: calc(100% / 2);
        }
    }  
}

@media(max-width: 375px) {
    .miscartas-wrapper {
        & > div {
            width: 100%;
        }
    }  
}

.download-link--img {
    margin: 1rem auto 2rem;
    display: flex;
    justify-content: space-around;
}

button.deletecard-btn {
    background: white;
    color: #333;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 1rem;
    padding: 0;
}

.miscartas-carta {
    position: relative;
}

.delete-card--confirmation-box {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: column;
    background: none;
    text-align: center;
    position: absolute;

    h4 {
        font-size: 0.85rem;
    }

    .delete-card--confirmation-box--actions {
        display: flex;
        align-items: center;
        gap: 1rem;

        button.delete-card--confirmation-box--confirm {
            background: red;
            color: #fff;
        }

        button.delete-card--confirmation-box--cancel {
            background: #333;
            color: #fff;
        }
    }
}

.delete-card--confirmation-box--inner {
    width: 100%;
    text-align: center;
    padding: 2rem 1rem;
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 2rem;
    border: 1px solid #f1f1f1;
    box-shadow: 0 2px 7px rgba(0,0,0,0.15);
}


</style>